export const MVP_LANDING_PATH = '/ai-mvp-development/'

export const MVP_CANONICAL_URL =
  'https://anglebrackets.io/ai-mvp-development/'

/** Served from web/static/og/ → /og/ai-mvp-development-og.png */
export const MVP_OG_IMAGE_URL =
  'https://anglebrackets.io/og/ai-mvp-development-og.png'

export const MVP_SEO = {
  title: 'AI MVP Development | Live in 4 Weeks | AngleBrackets',
  description:
    'Get a working AI MVP in 4 weeks. Fixed-scope pricing, senior engineers, you own 100% of the code. Free estimate within 1 hour.',
  canonical: MVP_CANONICAL_URL,
  siteName: 'AngleBrackets',
  image: MVP_OG_IMAGE_URL,
  imageAlt:
    'AngleBrackets AI MVP development — from idea to a working AI MVP in 4 weeks',
}


// Shown before Get a quote — also the first entries in MVP_FAQS (schema + bottom FAQ block).
export const MVP_PRE_QUOTE_FAQS = [
  {
    q: 'How much does MVP development cost?',
    a: "Projects start at $3,000, with the final price fixed once your scope is locked. The exact number depends on complexity, features, and stack — share your scope and budget range in the form and we'll send a free, no-obligation estimate within 1 hour.",
  },
  {
    q: 'Why not just use an AI app builder?',
    a: "AI app builders are good for a quick prototype or a first look at your idea, and if that's all you need, they can be a fine starting point. They tend to struggle once you need real users, secure logins, payments, or integrations, or when someone has to keep building on the code. We build the product properly from the start so it can grow past the demo stage.",
  },
  {
    q: 'Do you use AI to write the code?',
    a: 'Yes, our engineers use AI coding tools to move faster. Senior engineers decide the architecture, review the code, and write the tests, so AI speeds up the work without replacing engineering judgment. You get a team that is accountable for the result, not just a tool generating code.',
  },
]

// Visible FAQ copy AND FAQPage JSON-LD must stay identical (Google guideline).
export const MVP_FAQS = [
  ...MVP_PRE_QUOTE_FAQS,
  {
    q: 'How long does it take to build an MVP?',
    a: "4 weeks is the average once scope is locked. Simpler builds can ship faster, ones with heavier AI or integration work sometimes take a bit longer, you'll get a real number after the scoping call, not a generic range.",
  },
  {
    q: 'Can you help with product planning?',
    a: 'Yes. Most founders arrive with a rough idea, not a finished spec. Product planning, defining users, core flows, and what actually belongs in version one, is part of every engagement, not an extra.',
  },
  {
    q: 'Can you build AI-powered MVPs?',
    a: "Yes, it's most of what we do. OpenAI, Gemini, or Claude integrations, RAG knowledge bases, and automation get built in when the product actually needs them, not bolted on because AI is trending this quarter.",
  },
  {
    q: 'Do you provide UI/UX design?',
    a: "Yes, every MVP includes UI/UX design. You're not handed a wireframe and told to figure out the rest, the interface is designed to look and feel like a real product from day one.",
  },
  {
    q: 'What happens after the MVP is launched?',
    a: 'Post-launch support is included, not a separate contract you have to negotiate later. Most clients also continue with ongoing iteration once real users start generating feedback.',
  },
  {
    q: 'What is an MVP in software development?',
    a: "An MVP (minimum viable product) is the smallest version of a product that real users can actually use, not a mockup or a pitch deck. It's built to test whether the idea works before spending months on features nobody asked for yet.",
  },
]

export const getMvpServiceSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  serviceType: 'AI MVP Development',
  provider: {
    '@type': 'Organization',
    name: 'AngleBrackets',
    url: 'https://anglebrackets.io/',
  },
  areaServed: ['US', 'UK', 'Canada', 'UAE', 'Global'],
  description:
    'Fixed-scope AI MVP development for startups and founders, from product planning through launch, typically delivered in 4 weeks.',
  offers: {
    '@type': 'Offer',
    url: MVP_CANONICAL_URL,
  },
})

export const getMvpFaqSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: MVP_FAQS.map(({ q, a }) => ({
    '@type': 'Question',
    name: q,
    acceptedAnswer: {
      '@type': 'Answer',
      text: a,
    },
  })),
})
